/**
 * DomeCareTitle Component
 *
 * A simple reusable component that displays the DomeCare full logo.
 * Supports optional custom styling for the image via className.
 *
 * Props:
 * @param {string} imageClassName - Optional additional TailwindCSS class(es) applied to the logo image for custom styling.
 *
 * Behavior:
 * - Renders the DomeCare logo centered horizontally.
 * - Allows passing custom classes to adjust size, margin, or other styling.
 *
 * Usage:
 * ```tsx
 * <DomeCareTitle />
 * <DomeCareTitle imageClassName="w-1/2 mt-4" />
 * ```
 *
 * Notes:
 * - The logo image path is dynamically constructed using `BASE_LOCAL_IMAGES_DIR` and the constant `DomeCare_Full_Logo_IMG`.
 * - Uses TailwindCSS classes by default for layout and sizing.
 */

import React from "react";
import { BASE_LOCAL_IMAGES_DIR } from "../../utils/constants/CommonConstants";
import { DomeCare_Full_Logo_IMG } from "../../utils/constants/Images";

const DomeCareTitle: React.FC<{ imageClassName?: string }> = ({
  imageClassName,
}) => {
  return (
    <img
      src={`${BASE_LOCAL_IMAGES_DIR}/${DomeCare_Full_Logo_IMG}`}
      alt="base_logo"
      className={`mx-auto w-1/3 ${imageClassName}`}
    />
  );
};

export default DomeCareTitle;
